<template>
  <div class="com-player-marker-entrance-card" @click="openMarker">
    <img
      class="hot-event-icon"
      src="https://imgheybox.max-c.com/oa/2024/10/10/c3f99f788b8f1f0b3ba63bd5e9fb1faf.png"
      alt=""
    />
    <span class="hot-event-name">点击进入选手评价</span>
    <span class="hot-event-num">
      参与讨论
      <hb-icon common-arrow-right-line />
    </span>
  </div>
</template>
<script>
import { executeProtocol, executeProtocolOutApp } from '_lib/utils';
import { CptMixin } from '../../../mixins/CptMixin';

export default {
  mixins: [CptMixin],
  data() {
    return {
      card_data: {},
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      const card_data = await this.dataInfo.request;
      this.card_data = card_data;
    },
    openMarker() {
      let protocol = {
        protocol_type: 'openWindow',
        full_screen: true,
        mini_program: '1',
        webview: {
          url: `${window.$WEB_HOST}/tools/match_center/player_mark?match_id=${this.card_data.matchid}&league_id=${this.card_data.leagueid}&appid=${this.card_data.appid}`,
          bg: '000000',
          pull: false,
          refresh: false,
        },
        status_bar: {
          style: 'light',
        },
      };
      switch (this.articleInfo.source) {
        case 'share': {
          executeProtocolOutApp(protocol);
          break;
        }
        case 'post': {
          executeProtocol(protocol);
          break;
        }
      }
    },
  },
};
</script>

<style lang="less">
.com-player-marker-entrance-card {
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  padding: 8px;
  border-radius: 5px;
  background: #fafbfc;
  height: 32px;
  &::after {
    content: '';
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    width: 200%;
    height: 200%;
    border-radius: 10px;
    border: 1px solid #f3f4f5;
    transform: scale(0.5);
    transform-origin: left top;
    pointer-events: none;
  }
  .hot-event-icon {
    width: 16px;
    height: 16px;
    object-fit: scale-down;
  }
  .hot-event-name {
    flex: 1;
    width: 0;
    margin: 0 6px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 12px;
    font-weight: 500;
    font-family: 'PingFang SC';
    line-height: 17px;
    color: rgba(20, 25, 30, 1);
  }
  .hot-event-num {
    display: inline-flex;
    align-items: center;
    font-size: 12px;
    line-height: 16px;
    color: rgba(140, 145, 150, 1);
    i {
      font-size: 12px;
      margin-left: 2px;
    }
  }
}
</style>
